import React from 'react'
import { ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Label, LabelList } from 'recharts'

import { funnelChartData } from '../hooks/useGetAnalytics/funnel'

// FunnelChart
//
// A line chart of the session funnel across the reporting period: starts with
// the unique contact count and steps down through basic plans, health
// conditions, medications, providers, and predict plans, showing the count of
// sessions reaching each step. Built from the same raw analytics rows
// (detailData) as the funnel CSV export.
const FunnelChart = ({ detailData }) => {
  const data = funnelChartData(detailData)
  const hasData = data.length > 0 && data[0].count > 0

  if (!hasData) return null

  return (
    <div className='bg-zinc-100 p-4 m-4 rounded-sm'>
      <h3 className='mb-2 text-lg font-semibold text-gray-800'>Session Funnel</h3>
      <ResponsiveContainer height={320} width='100%'>
        <LineChart data={data} margin={{ top: 20, right: 30, bottom: 40, left: 40 }}>
          <CartesianGrid stroke='#ccc' strokeDasharray='7' />
          <XAxis dataKey='label' interval={0} angle={-15} textAnchor='end' height={60}>
            <Label className='text-2xl' position='bottom' offset={20}>
              Funnel Step
            </Label>
          </XAxis>
          <YAxis allowDecimals={false}>
            <Label value='Sessions' angle={-90} position='left' />
          </YAxis>
          <Tooltip />
          <Line
            type='monotone'
            dataKey='count'
            stroke='#2781DB'
            strokeWidth={2}
            dot={{ r: 4 }}
            isAnimationActive={false}
          >
            <LabelList dataKey='count' position='top' />
          </Line>
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

export default FunnelChart
